// dev(dev.korehalal.com) 배포에서만 favicon·로고를 DEV 배지 버전으로 바꾼다.
// 판별은 기존 dev 게이팅과 동일하게 REACT_APP_RETURN_ENV 를 쓴다
// (NODE_ENV 는 dev/prod 둘 다 production 이라 사용 불가).
export const IS_DEV =
  (process.env.REACT_APP_RETURN_ENV || "").toUpperCase() === "DEV";

export const LOGO_SRC = IS_DEV
  ? "/illustrations/logo_dev.svg"
  : "/illustrations/logo.svg";

export const LOGO_WRAP_SRC = IS_DEV
  ? "/illustrations/logo_wrap_dev.svg"
  : "/illustrations/logo_wrap.svg";

export const LOGO192_SRC = IS_DEV ? "/logo192-dev.png" : "/logo192.png";

// index.html 의 favicon·manifest <link> 는 정적이라 빌드 타임 분기가 없다.
// dev 빌드에서 로드 직후 href 를 dev 파일로 교체한다.
// manifest 도 함께 교체해야 PWA 설치/홈 화면 바로가기 아이콘이 dev 로 바뀐다
// (manifest.json 의 icons 는 prod 자산을 가리키므로 dev 매니페스트로 스왑).
export function applyDevFavicon() {
  if (!IS_DEV || typeof document === "undefined") return;
  const swap = (selector, href) => {
    document.querySelectorAll(selector).forEach((el) => el.setAttribute("href", href));
  };
  swap('link[rel="icon"][sizes="16x16"]', "/favicon-16x16-dev.png");
  swap('link[rel="icon"][sizes="32x32"]', "/favicon-32x32-dev.png");
  swap('link[rel="icon"]:not([sizes])', "/favicon-dev.ico");
  swap('link[rel="apple-touch-icon"]', "/apple-touch-icon-dev.png");
  swap('link[rel="manifest"]', "/manifest-dev.json");
}
